import React, { useEffect, useState } from 'react'
import { useCalc } from '../../context/CalcContext'
import {
  VictoryChart,
  VictoryContainer,
  VictoryPie,
  VictoryTheme,
  VictoryLabel
} from 'victory'
import * as styles from './Dilution.module.scss'

const TYPICAL_DILUTION = 0.2

const Dilution = () => {
  const [dilutionPie, setDilutionPie] = useState([])
  const [dilutionAvoided, setDilutionAvoided] = useState(0)
  const { dataSetRunway, runwayWithout, runwayWith } = useCalc()

  useEffect(() => {
    const preMoneyWithout = dataSetRunway[runwayWithout]?.valuation
    const preMoneyWith = dataSetRunway[runwayWith]?.valuation
    const raiseWithout =
      preMoneyWithout / (1 - TYPICAL_DILUTION) - preMoneyWithout
    const dilutionWithout = raiseWithout / (preMoneyWithout + raiseWithout)
    const dilutionWith = raiseWithout / (preMoneyWith + raiseWithout)
    const dilutionAvoided = (dilutionWithout - dilutionWith) / dilutionWithout
    setDilutionAvoided(dilutionAvoided)
    setDilutionPie([
      { x: 'Dilution \n avoided', y: (dilutionAvoided || 1) * 100 },
      { x: '', y: (1 - (dilutionAvoided || 1)) * 100 }
    ])
  }, [dataSetRunway, runwayWith, runwayWithout])

  return (
    <div className={styles.VictoryContainer}>
      {dilutionAvoided < 0 ? (
        <div className={styles.NoNeed}>
          <h3>You don't seem to need fund raising.</h3>
        </div>
      ) : (
        <VictoryPie
          animate
          colorScale={['#fee100', '#f5f5f5']}
          style={{
            labels: {
              fontFamily: 'Roobert, sans-serif',
              fontSize: 18,
              fontWeight: 'bold'
            }
          }}
          data={dilutionPie}
          labels={({ datum }) => {
            return datum.x
              ? parseFloat(datum.y).toFixed(1) + '% \n' + datum.x
              : ''
          }}
          labelRadius={({ innerRadius, radius }) => radius * 0.2}
        />
      )}
    </div>
  )
}

export default Dilution
